import { render, staticRenderFns } from "./entry_sjh2.vue?vue&type=template&id=28b83d76&scoped=true"
import script from "./entry_sjh2.vue?vue&type=script&lang=js"
export * from "./entry_sjh2.vue?vue&type=script&lang=js"
import style0 from "./entry_sjh2.vue?vue&type=style&index=0&id=28b83d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b83d76",
  null
  
)

export default component.exports